import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Paper } from "@material-ui/core";
import { BootstrapTable } from "react-bootstrap-table";

function WagerTypeList({
  className = "",
  initialData = [],
  title,
  itemKey,
  getUrl,
  children,
  itemSelected = () => {},
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const [data, setData] = useState(initialData);

  /**
   * GET
   */
  const requestData = useCallback(() => {
    const url =
      process.env.REACT_APP_API2_URL +
      (getUrl instanceof Function ? getUrl(userInfo) : getUrl);
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setData(data);
        if (data) {
          const row = data?.[0];
          setSelectedRow(row?.[itemKey]);
          itemSelected(row);
        }
      });
  }, [getUrl, itemKey, userInfo, itemSelected]);

  /**
   * Initial load
   */
  useEffect(() => {
    if (getUrl) {
      requestData();
    }
  }, [getUrl, requestData]);

  /**
   * TABLE OPTIONS
   */
  const options = {
    pagination: false, // Desactiva la paginación
    hideSizePerPage: true,
    sizePerPage: data.length, // Asegúrate de mostrar todas las filas
    pageStartIndex: 1,
    paginationSize: 1,
    prePage: "<",
    nextPage: ">",
    paginationShowsTotal: true,
    paginationPosition: "bottom",
    withFirstAndLast: false,
  };

  const [selectedRow, setSelectedRow] = useState(null);
  const handleRowClick = (row) => {
    setSelectedRow(row[itemKey]);
    itemSelected(row);
  };

  const selectRow = {
    mode: "radio", // 'checkbox' for multiple selection, 'radio' for single selection
    clickToSelect: true,
    selected: [selectedRow],
    onSelect: handleRowClick,
  };

  return (
    <div id="main-div" className={`${className} !h-max w-60 flex-grow-0`}>
      <Paper>
        <h2>{title}</h2>

        <BootstrapTable
          data={data}
          options={options}
          pagination={true}
          selectRow={selectRow}
          version="4"
          hover
        >
          {children}
        </BootstrapTable>
      </Paper>
    </div>
  );
}

export default WagerTypeList;
